module.exports = __webpack_public_path__ + "fd73a6eb26a08ee46e7fd3cc34e7f6bf.ico";


/*****************
 ** WEBPACK FOOTER
 ** ./modules/favicon.ico
 ** module id = 21
 ** module chunks = 0
 **/